import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Handle, Position } from '@xyflow/react'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'
import { getVariantStyles } from './variants'

const HANDLE_STYLE = { width: 5, height: 5, opacity: 0 }

function FlowGraphPill ({ data, selected }) {
  const {
    nameValue, nameConfig,
    variant = 'default',
    color
  } = data

  const { formatter } = useFormattingContext()
  const variantStyles = getVariantStyles(variant, color)
  const isFilled = variant !== 'default'

  const displayValue = nameConfig?.format
    ? formatter(nameValue, nameConfig.format)
    : nameValue

  const containerStyle = useMemo(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: variantStyles.background,
    color: isFilled ? variantStyles.color : 'var(--root-color)',
    border: `1.5px solid ${selected ? variantStyles.selectedBorderColor : variantStyles.borderColor}`,
    borderRadius: 999,
    padding: '6px 18px',
    fontSize: '0.75rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    boxShadow: selected ? '0 0 0 2px rgba(0,0,0,0.08)' : 'none',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.4
  }), [variantStyles, isFilled, selected])

  const handleColor = isFilled ? variantStyles.borderColor : 'var(--color-neutral-300)'

  return (
    <div style={containerStyle}>
      <Handle type='target' position={Position.Top} style={{ ...HANDLE_STYLE, background: handleColor }} />
      <span className={nameConfig?.className || ''} style={nameConfig?.style}>
        {displayValue}
      </span>
      <Handle type='source' position={Position.Bottom} style={{ ...HANDLE_STYLE, background: handleColor }} />
    </div>
  )
}

FlowGraphPill.propTypes = {
  data: PropTypes.shape({
    nameValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nameConfig: PropTypes.object,
    variant: PropTypes.string,
    color: PropTypes.object
  }),
  selected: PropTypes.bool
}

export default memo(FlowGraphPill)
